import {connect} from "react-redux"
import {QuickLinkProps} from "../QuickLink"
import {State} from "../../ducks"
import {SupportedRegionTypes, SupportedRegionSubTypes} from "../../models/regions"

export const mapStateToProps = (state: State) => {
    const {
        request: {siteUrl},
        countrySelector: {isEnableCountrySelectorButton},
    } = state

    const quickLinkObject = state.data?.regions.find(region => region.type === SupportedRegionTypes.StaticBannerLinks)
    const quickLinks = quickLinkObject?.elements
        .filter(link => link.type === SupportedRegionSubTypes.Link)
        .map(({text, url, accessibilityText, icon}) => {
            return {
                text,
                url: `${siteUrl}${url}`,
                accessibilityText: accessibilityText ?? "",
                icon,
            } as QuickLinkProps
        })
    const hasQuickLinks = quickLinks && quickLinks?.length > 0

    return {
        templating: state.template,
        hasQuickLinks,
        countrySelectEnabled: isEnableCountrySelectorButton,
    }
}

export default connect(mapStateToProps)
